export const ROOT_ORGANIZATION_ID = '00000000-0000-0000-0000-000000000000';

export const DASHBOARD_MENU = [
  {
    name: '',
    text: 'Dashboard',
    icon: 'ampdashboard',
    showCount: false,
  },
  {
    name: 'favorites',
    text: 'Favorites',
    icon: 'favorites',
    isLast: true,
    showCount: true,
  },
  {
    name: 'drafts',
    text: 'Drafts',
    icon: 'edit',
    showCount: true,
  },
  {
    name: 'live-amps',
    text: 'Live',
    icon: 'live',
    isLast: true,
    showCount: true,
  },
];

export const ACCOUNT_MENU = [
  {
    name: 'account',
    text: 'Account',
    isLabel: true,
  },
  {
    name: 'settings',
    text: 'Settings',
  },
  {
    name: 'administration',
    text: 'Administration',
    isLabel: true,
  },
  {
    name: 'organization',
    text: 'Organization',
  },
  {
    name: 'manage-members',
    text: 'Manage members',
  },
  {
    name: 'plans',
    text: 'Plans',
  },
  {
    name: 'billing',
    text: 'Billing',
  },
];

export const PROFILE_MENU = [
  {
    name: 'settings',
    label: 'Account settings',
  },
  {
    name: 'organization',
    label: 'Organization settings',
  },
  {
    name: 'manage-members',
    label: 'Manage team',
  },
  {
    name: 'plans',
    label: 'Plans',
  },
  {
    name: 'billing',
    label: 'Billing',
  },
  {
    name: 'logout',
    label: 'Log out',
  },
];

export const HELP_MENU = [
  {
    label: 'Amplify Support Portal',
    url: 'https://help.amplify.anthill.technology/sup',
  },
];

export const ROLE_TYPE = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  EDITOR: 'Editor',
  GUEST: 'Guest',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  TRIAL_ACTIVE: 'TRIAL_ACTIVE',
  TRIAL_EXPIRED: 'TRIAL_EXPIRED',
  CANCELED: 'CANCELED',
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
};

export const AMP_CONNECTION_STATUS_MESSAGE = {
  SUCCESSFUL: 'Connected and ready to deploy.',
  FAILED: 'The script was not detected on the website',
  ERROR: 'Something is not working, try verifying again or...',
};

export const AMP_CONNECTION_STATUS = {
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
  ERROR: 'ERROR',
};

export const AMP_DNS_CONNECTION_STATUS = {
  SUCCESS: 'SUCCESS',
  PENDING_VALIDATION: 'PENDING_VALIDATION',
  FAILED: 'FAILED',
};

export const ROLE_RANK = {
  Editor: 0,
  Admin: 1,
  Owner: 2,
};

export const subscriptionActiveStatuses = () => [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.PAYMENT_REQUIRED];

export const subscriptionActiveStatusesWithTrial = () => [
  SUBSCRIPTION_STATUS.ACTIVE,
  SUBSCRIPTION_STATUS.TRIAL_ACTIVE,
  SUBSCRIPTION_STATUS.PAYMENT_REQUIRED,
];

export const favIconUrl = 'https://res.cloudinary.com/act-amp/image/upload/v1677685287/assets/favicon_fznenm.png';
